module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-form"
  }, [(!_vm.isDataLoaded) ? _c('loader', {
    staticClass: "panel-loader"
  }) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.handleSubmission
    }
  }, [(_vm.isDataLoaded) ? _c('div', {
    staticClass: "dynamic-form-body"
  }, [_c('formly-form-flex', {
    ref: "formBody",
    attrs: {
      "form": _vm.form,
      "fields": _vm.fields,
      "model": _vm.model
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.errors.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      staticClass: "errors"
    }, [_vm._v(_vm._s(error))])
  })) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4351a74"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/DynamicForm.vue
// module id = 1115
// module chunks = 0